import { BuildPriorityEnums } from '@/components/agents-table/AgentActionMenu.types';
import { Agent_AssignPriority } from '@/graphql/codegen/generated/graphql';

export const BUILD_PRIORITY_LABEL_MAP = {
  [BuildPriorityEnums.HighBuildPriority]: '1 - High',
  [BuildPriorityEnums.AboveNormalBuildPriority]: '2 - Above Normal',
  [BuildPriorityEnums.NormalBuildPriority]: '3 - Normal',
  [BuildPriorityEnums.BelowNormalBuildPriority]: '4 - Below Normal',
  [BuildPriorityEnums.LowBuildPriority]: '5 - Low',
};

export const ASSIGNMENT_PRIORITY_LABEL_MAP = {
  [Agent_AssignPriority.HighAssignPriority]: '1 - High',
  [Agent_AssignPriority.AboveNormalAssignPriority]: '2 - Above Normal',
  [Agent_AssignPriority.NormalAssignPriority]: '3 - Normal',
  [Agent_AssignPriority.BelowNormalAssignPriority]: '4 - Below Normal',
  [Agent_AssignPriority.LowAssignPriority]: '5 - Low',
};

export const LOG_LEVEL_LABEL_MAP = {
  0: '1 - Minimal',
  1: '2 - Basic',
  2: '3 - Intermediate',
  3: '4 - Extended',
  4: '5 - Detailed',
};

// eslint-disable-next-line no-shadow
export enum SYSTEM_BUILD_GROUPS {
  Default = 'Default',
  Universal = '__UNIVERSAL__',
}
